import {
  animate,
  animation,
  style,
  transition,
  trigger,
} from '@angular/animations';

export const AlertFade = trigger('alertFade', [
  transition(
    ':enter',
    animation([
      style({
        opacity: 0,
        transform: 'translateY(-10px)',
        scale: 0.95,
      }),
      animate(
        '0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94)',
        style({
          opacity: 1,
          transform: 'translateY(0)',
          scale: 1,
        }),
      ),
    ]),
  ),
  transition(
    '* => *',
    animation([
      style({
        opacity: 0.7,
        transform: 'scale(0.98)',
      }),
      animate(
        '0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)',
        style({
          opacity: 1,
          transform: 'scale(1)',
        }),
      ),
    ]),
  ),
]);

export const AlertPulse = trigger('alertPulse', [
  transition(
    '* => *',
    animation([
      style({ transform: 'scale(1)' }),
      animate('0.1s ease-in', style({ transform: 'scale(1.02)' })),
      animate('0.1s ease-out', style({ transform: 'scale(1)' })),
    ]),
  ),
]);
